import useCurrencyStore from "store/currencyStore";
import useCurrencies from "api/CurrencyResource/useCurrencies";

export default function CurrencySwitcher({ value, onChange }) {
    const { currency, setCurrency } = useCurrencyStore();
    const { data: currencies = [], isLoading, isError, refetch } = useCurrencies();
    if (isError) return <button type="button" onClick={() => refetch()} className="text-sm text-red-700">Retry loading currencies</button>;
    return <select aria-label="Currency" value={value || currency} disabled={isLoading || !currencies.length}
        onChange={(event) => (onChange || setCurrency)(event.target.value)}
        className="rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 focus:ring-2 focus:ring-akgreen">
        {!currencies.length && <option>{isLoading ? "Loading currencies…" : "No currencies available"}</option>}
        {currencies.map((item) => <option key={item.code} value={item.code}>{item.label} ({item.code})</option>)}
    </select>;
}
